import React from 'react';
import withRouter from './common/withRouter';

import {
    Menu,
} from 'semantic-ui-react'

const NonAuthLayout = ({children}) => {
    return (
            children
    );
};

export default withRouter(NonAuthLayout);
